import { useQuery } from "convex/react";
import { api } from "convex/_generated/api";

export type ModeratorRole = "admin" | "moderator" | "volunteer" | null;

export function useModeratorRole() {
  const role = useQuery(api.moderation.getMyRole) as ModeratorRole | undefined;

  return {
    role: role ?? null,
    isLoading: role === undefined,
    isAdmin: role === "admin",
    isModerator: role === "admin" || role === "moderator",
    isAnyModerator: role !== null && role !== undefined,
  };
}
